// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection, pin) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_TRACK_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

export const updateTrackPin = pin =>

    dispatch => {

        dispatch({
            property: 'pin',
            type: actions.UPDATE_CLAIM_TRACK_PROPERTY,
            value: pin
        });

        if (pin === '') {

            dispatch({
                property: 'useAmount',
                type: actions.UPDATE_CLAIM_TRACK_FORM_VALIDATION,
                validity: true
            });

        }

    };

export const updateTrackClaimProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_TRACK_PROPERTY,
    value
});

export const updateTrackClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_TRACK_WORK_ORDER_ONE,
    workOrder
});

export const updateTrackClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_TRACK_WORK_ORDER_TWO,
    workOrder
});

export const updateTrackClaimApplication = (application, collection) => ({
    application,
    collection,
    type: actions.UPDATE_CLAIM_TRACK_APPLICATION
});

export const updateTrackClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_TRACK_REPAIR_NUMBER
});

export const updateOwnershipStatusDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_TRACK_OWNERSHIP_STATUS
});

export const updateTrackClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_TRACK_FAILURE_PART
});

export const resetTrackPinDetails = () => ({
    type: actions.RESET_CLAIM_TRACK_PIN_DETAILS
});

export const updateTrackClaimFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_TRACK_FAILURE_DATE
});

export const updateTrackClaimRepairDate = repairDate => ({
    repairDate,
    type: actions.UPDATE_CLAIM_TRACK_REPAIR_DATE
});

export const updateTrackClaimUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_TRACK_USE_AMOUNT_UNIT,
    unitCollection
});

export const updateTrackClaimUseAmount = (amount, index) => ({
    amount: validAmountOfUse(amount),
    index,
    type: actions.UPDATE_CLAIM_TRACK_USE_AMOUNT
});

export const updateTrackClaimInputOnBlur = (property, value, claim) => ({
    property,
    type: actions.UPDATE_CLAIM_TRACK_FORM_VALIDATION,
    validity: mapFormValidation(property, value, claim)
});

export const resetTrackClaim = () => ({
    type: actions.RESET_CLAIM_TRACK
});

export const resetTrackProductDetails = () => ({
    type: actions.RESET_CLAIM_TRACK_PRODUCT_DETAILS
});

export const updateInstalledByDropDown = (key, installedByCollection) =>

    dispatch => {

        dispatch({
            installedByCollection,
            key,
            type: actions.UPDATE_CLAIM_TRACK_INSTALLED_BY
        });

        if (key === 'R') {

            dispatch({
                property: 'pin',
                type: actions.UPDATE_CLAIM_TRACK_FORM_VALIDATION,
                validity: true
            });

        }

        if (key !== 'R') {

            dispatch({
                type: actions.RESET_CLAIM_TRACK_REPLACEMENT_DETAILS
            });

            dispatch({
                property: 'previousInvoiceNumber',
                type: actions.UPDATE_CLAIM_TRACK_FORM_VALIDATION,
                validity: true
            });

            dispatch({
                property: 'retailInstallDate',
                type: actions.UPDATE_CLAIM_TRACK_FORM_VALIDATION,
                validity: true
            });

        }

    };

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_TRACK_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/track/action-creators/claim-details.js